module.exports = __webpack_public_path__ + "static/travel-b33b645217f802145aa08cdcd3b272d6.png";